import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Contact() {
    const initialFormData = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        msg: '',
      };
    
      const [formData, setFormData] = useState(initialFormData);
      const [submitStatus, setSubmitStatus] = useState(null);
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Check if any of the form fields are empty
        if (
          formData.name.trim() === '' ||
          formData.email.trim() === '' ||
          formData.subject.trim() === '' ||
          formData.phone.trim() === '' ||
          formData.msg.trim() === ''
        ) {
          // If any field is empty, display an error message and return
          setSubmitStatus('error');
          return;
        }
    
        try {
          // Your fetch request to send the email
          // Assuming it is successful for demonstration purposes
          setSubmitStatus('success');
          setFormData(initialFormData); // Reset form data to initial empty values
        } catch (error) {
          console.error('Error:', error);
          setSubmitStatus('error');
        }
      };
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
  return (
    <div>
      <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Contact Us</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Contact Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row no-gutters">
                <div className="col-lg-7">
                    <div className="contact_area">
                        <div className="section-header">
                            <p className="section_count"></p>
                            <h3 className="title">Get In Touch</h3>
                        </div>
                        {submitStatus === 'success' && (
                        <div className='success-message mb-3'>
                            Mail has been sent successfully!
                        </div>
                        )}
                        <form onSubmit={handleSubmit} className="row form_style style_two">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Your Name" autoComplete="off" required/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="Your Email" autoComplete="off" required/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="form-control" placeholder="Your Phone" autoComplete="off" required/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="form-control" placeholder="Your Subject" autoComplete="off" required/>
                                </div> 
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <textarea name="msg" rows="5" value={formData.msg} onChange={handleChange} className="form-control" placeholder="Write Something..." autoComplete="off" required></textarea>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <button type="submit" className="thm-btn btn-rounded w-100">
                                    <span className="button_title" onClick={handleSubmit}>Submit</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="h-100 contact_info thm-bg-color-two">
                        <div className="section-header">
                            <h3 className="title text-white">Contact Info</h3>
                        </div>
                        <div className="footer">
                            <ul className="ft_contact ft_menu mb-xl-30">
                                <li>
                                    <Link to="#">
                                        <i className="fas fa-phone-volume"></i>
                                        (+347) 123 456 7890
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fas fa-envelope"></i>
                                        example@example.com
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fas fa-map-marker-alt"></i>
                                        Street, 3821 Ben Street. NY 14424
                                    </Link>
                                </li>
                            </ul>
                            <ul className="ft_social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="relative contact_map" >
                        <iframe title="Google Map" width="100%" height="100%" frameBorder="0" style={{ border: 0 }} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1
                        93595.5023963866!2d-74.11808650866945!3d40.70582563036137!2m3!1f0!2f0!3f0!3m
                        2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20Yo
                        rk%2C%20NY%2C%20USA!5e0!3m2!1sen!2suk!4v1643669876474!5m2!1sen!2suk" allowFullScreen=""></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Contact